<template>
  <La0 :ratio="'1fr 600px'" :style="{height: '100vh'}" class="announcementEdit">
  <L1  slot="left">
    <template slot="slot_title">
      <Select :width="'185px'" @input="interfaceid=$event" :defaultValue="interfaceid">
        <option :value="null">全部區域</option>
        <option :value="'client'">手機顧客端</option>
        <option :value="'staff'">內部系統端</option>
      </Select>
    <RoundBtn :style="{marginLeft: 'auto'}" :bg="'var(--color-checked)'" :text="'新增公告'" :icon="'add'" @click="addnew=true"/>
    </template>
    <Table :rows="rows">
      <template slot="slot_head">
        <th :style="{width: '60px'}">No.</th>
        <th :style="{width: '160px', textAlign: 'start'}">標題</th>
        <th :style="{width: '360px',textAlign: 'start'}">內容</th>
        <th :style="{width: '160px',textAlign: 'start'}">公告區域</th>
        <th :style="{width: '160px',textAlign: 'start'}">起迄</th>
        <th :style="{width: '60px'}">不顯示</th>
        <th :style="{width: '60px'}">編輯</th>
        <th :style="{width: '60px'}">刪除</th>
      </template>
      <tr slot-scope="{item, index}" @click="selected=item" :class="selected?._id===item._id&&'selected'" :style="{height: '120px'}">
        <td>{{index+1}}</td>
        <td :style="{
          textAlign: 'start', whiteSpace: 'nowrap',
          width: '160px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'
        }">{{item.name}}</td>
        <td :style="{width: '360px', maxWidth: '360px', textAlign: 'start'}" class="toolong" v-if="item.mode==='content'">{{item.content}}</td>
        <td v-else-if="item.image"><div :style="{width: '300px', height: '120px', backgroundImage: `url(.${item.image})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat'}"></div></td>
        <td :style="{width: '360px', maxWidth: '160px', textAlign: 'start', color: 'var(--color-pri)'}"
        v-html="(item.interface||[]).map(e => e==='client'?'手機顧客端':'內部系統端').join('<br>')">
        </td>
        <td :style="{textAlign: 'start'}"><span :style="{whiteSpace: 'nowrap'}">{{toDate(item.startTime)}}</span><br>{{toDate(item.expireTime)}}</td>
        <td @click.stop="update(index, item._id, !item.actived)">
          <svg width="35" height="27" viewBox="0 0 35 27" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="item.actived">
          <path d="M17.6281 26.3949C5.14304 26.3949 0.882747 16.1728 0.155516 14.1237C-0.0576381 13.522 -0.0516011 12.8642 0.173163 12.2666C0.91479 10.2978 5.21456 0.455316 17.0713 0.0139798C28.9805 -0.430601 33.9198 9.86151 34.7886 11.9291C35.0403 12.5281 35.0682 13.1975 34.8671 13.8155C34.1826 15.916 30.1359 26.3949 17.6281 26.3949ZM2.5564 13.2707C3.43688 15.7514 7.12551 23.8461 17.6281 23.8461C28.1056 23.8461 31.6173 15.5641 32.4444 13.026C32.456 12.9903 32.4546 12.9513 32.4398 12.917C31.3796 10.3937 27.1471 2.1896 17.1656 2.56093C7.1766 2.93319 3.45824 10.7711 2.55686 13.1646C2.54433 13.1989 2.54433 13.2364 2.5564 13.2707ZM17.5009 19.8954C14.7628 19.9014 12.2914 18.2594 11.2391 15.7361C10.1872 13.2128 10.7621 10.3052 12.6963 8.37015C14.63 6.43514 17.5417 5.85472 20.0717 6.89919C22.6017 7.94365 24.2521 10.4076 24.2521 13.1409C24.2517 16.8654 21.2318 19.8866 17.5009 19.8954ZM17.5009 8.93527C15.7961 8.93156 14.2571 9.95377 13.6023 11.5253C12.9475 13.0964 13.3056 14.9072 14.5097 16.1116C15.7139 17.3165 17.5264 17.6781 19.1021 17.0272C20.6777 16.3768 21.705 14.8428 21.705 13.1409C21.7045 10.8221 19.8237 8.94036 17.5009 8.93527Z" fill="var(--color-pri)"/>
          </svg>
          <svg width="35" height="27" viewBox="0 0 35 27" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
          <path d="M5.14441 21.2314C4.77707 21.2319 4.42738 21.073 4.18589 20.7958L3.9574 20.5339C2.30367 18.6623 1.01403 16.4973 0.155351 14.1511C-0.0578091 13.5483 -0.0513075 12.8898 0.172998 12.2912C0.915112 10.3189 5.215 0.459658 17.0716 0.0180127C19.3073 -0.0827623 21.5415 0.239997 23.6568 0.969107C24.3223 1.20131 24.6734 1.92949 24.4412 2.59498C24.209 3.26046 23.4808 3.61155 22.8153 3.37935C21 2.75705 19.0834 2.48213 17.1659 2.56897C7.1771 2.94142 3.45864 10.7931 2.55723 13.1908C2.5447 13.2251 2.5447 13.2627 2.55723 13.2971C3.30446 15.3354 4.42645 17.2162 5.86563 18.8416L6.10247 19.1128C6.43313 19.4894 6.513 20.0244 6.30635 20.4809C6.10015 20.9374 5.64597 21.2309 5.14441 21.2314ZM17.6289 26.4434C15.6436 26.4564 13.668 26.1703 11.7682 25.5944C11.0966 25.385 10.7209 24.6717 10.9281 23.9997C11.1357 23.3272 11.848 22.9497 12.521 23.1554C14.177 23.6551 15.8986 23.9026 17.6284 23.8901C28.1058 23.8901 31.6181 15.594 32.4447 13.0514C32.4563 13.0157 32.4545 12.9771 32.4401 12.9428C31.5856 10.9579 30.4092 9.12817 28.958 7.52692C28.4815 7.00818 28.5159 6.20152 29.0346 5.7255C29.5533 5.24903 30.36 5.28339 30.836 5.80213C32.4837 7.62073 33.8189 9.69892 34.7885 11.9531C35.0402 12.5531 35.0681 13.2233 34.8675 13.8423C34.1834 15.9465 30.1371 26.4434 17.6289 26.4434ZM12.0236 14.4432C11.685 14.4432 11.3609 14.3086 11.1217 14.0689C10.8826 13.8293 10.7483 13.5047 10.7493 13.1666C10.7493 9.43514 13.7702 6.40817 17.5021 6.40028C18.2071 6.40028 18.7788 6.97149 18.7788 7.67692C18.7788 8.38188 18.2071 8.95356 17.5021 8.95356C15.1792 8.95867 13.2984 10.8432 13.2984 13.1666C13.2988 13.5052 13.1646 13.8298 12.9259 14.0689C12.6863 14.3086 12.3621 14.4432 12.0236 14.4432ZM17.5017 19.9325C16.7967 19.9325 16.225 19.3613 16.225 18.6558C16.225 17.9509 16.7967 17.3792 17.5017 17.3792C19.8246 17.3741 21.7054 15.4895 21.7054 13.1666C21.6915 12.7022 21.9311 12.2675 22.331 12.0311C22.7308 11.7948 23.2273 11.7948 23.6271 12.0311C24.027 12.2675 24.2666 12.7027 24.2527 13.1666C24.2531 16.8976 21.2327 19.9246 17.5017 19.9325ZM6.45031 25.6455C5.93436 25.6446 5.46949 25.3335 5.27259 24.8565C5.07522 24.3796 5.18482 23.8311 5.54937 23.4666L28.1936 0.774522C28.6919 0.277149 29.4995 0.278077 29.9968 0.77638C30.4942 1.27468 30.4933 2.08228 29.995 2.57965L7.35078 25.2717C7.11255 25.5113 6.78793 25.646 6.45031 25.6455Z" fill="#B9B9B9"/>
          </svg>
        </td>
        <td @click.stop="editfn(item)">
          <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_629_372)">
          <circle cx="22.5" cy="22.5" r="17.5" fill="var(--color-pri)"/>
          </g>
          <path d="M31.2927 16.9118L28.0389 13.6462C27.6142 13.2459 27.0578 13.0162 26.4753 13.0008C25.8929 12.9854 25.3252 13.1855 24.8801 13.5628L14.1925 24.289C13.8087 24.6775 13.5697 25.1867 13.5156 25.7311L13.005 30.7009C12.989 30.8755 13.0116 31.0514 13.0711 31.2162C13.1306 31.381 13.2256 31.5306 13.3494 31.6544C13.4603 31.7648 13.5919 31.8522 13.7366 31.9115C13.8813 31.9708 14.0362 32.0009 14.1925 32H14.2994L19.2513 31.5471C19.7938 31.4929 20.3011 31.253 20.6882 30.8678L31.3758 20.1416C31.7906 19.7017 32.0148 19.1148 31.9992 18.5094C31.9837 17.904 31.7296 17.3295 31.2927 16.9118ZM27.2551 20.8924L24.0726 17.6984L26.3883 15.3148L29.6302 18.5684L27.2551 20.8924Z" fill="white"/>
          <defs>
          <filter id="filter0_d_629_372" x="0" y="0" width="45" height="45" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset/>
          <feGaussianBlur stdDeviation="2.5"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_629_372"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_629_372" result="shape"/>
          </filter>
          </defs>
          </svg>
        </td>
        <td @click.stop="beforeDel(index, item._id, item.name)">
          <svg width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.424 12.8205V20.3555C15.424 20.9882 15.9367 21.501 16.5694 21.501C17.2021 21.501 17.7149 20.9882 17.7149 20.3555V12.8205C17.7149 12.1878 17.2021 11.675 16.5694 11.675C15.9367 11.6755 15.424 12.1883 15.424 12.8205ZM8.55115 12.8205V20.3555C8.55115 20.9882 9.06437 21.501 9.69662 21.501C10.3289 21.501 10.8421 20.9882 10.8421 20.3555V12.8205C10.8421 12.1878 10.3293 11.675 9.69662 11.675C9.06392 11.675 8.55115 12.1883 8.55115 12.8205Z" fill="#FF6B6B"/>
          <path d="M7.81596 5.85548L7.49738 3.58736L16.5716 2.31124L16.8911 4.5807L7.81596 5.85548ZM23.6954 3.62405L19.1592 4.26122L18.7341 1.2396C18.6849 0.892831 18.4988 0.580512 18.2173 0.372449C17.6298 -0.070972 16.7399 -0.0239899 16.2575 0.0426798L7.17209 1.3197C5.50445 1.55461 5.01852 2.41818 5.12188 3.14797L5.54561 6.17451L1.00939 6.81212C0.597287 6.86134 0.244251 7.12981 0.086302 7.51327C-0.0716471 7.89673 -0.00989932 8.33613 0.247831 8.66142C0.506008 8.98672 0.91945 9.1469 1.32886 9.08023L2.97279 8.85025C2.87838 9.01356 2.82692 9.19791 2.82289 9.38629V25.4206C2.82289 26.6851 3.85023 27.7129 5.11383 27.7129H21.1495C22.4144 27.7111 23.4391 26.6855 23.4404 25.4206V9.38584C23.4404 8.75315 22.9276 8.24037 22.2949 8.24037C21.6622 8.24037 21.1495 8.7536 21.1495 9.38584V25.4215L5.11293 25.4201V9.38584C5.11248 9.09008 4.99704 8.8064 4.79077 8.59431L24.0149 5.89217C24.6413 5.80357 25.0772 5.22413 24.9886 4.5977C24.9492 4.29567 24.7895 4.02183 24.546 3.83838C24.3022 3.65537 23.9952 3.57797 23.6941 3.62361H23.6954V3.62405Z" fill="#FF6B6B"/>
          </svg>
        </td>
      </tr>
    </Table>
  </L1>
  <template v-if="addnew">
  <div class="addtitle">新增公告</div>
  <div class="addcontent">
    <div class="inputColFlex">
      <div :style="{marginRight: '20px'}">公告類型:</div>
      <RT  :defaultValue="editItem.mode==='content'?'文字公告':'圖片公告'" @input="editItem.mode=$event==='文字公告'?'content': 'image'" :options="['文字公告', '圖片公告']"></RT>
    </div>
    <div class="inputColFlex">
      <div :style="{marginRight: '20px'}">公告區域:</div>
      <Checkbox :options="['手機顧客端', '內部系統端']" :style="{flexDirection: 'row', flexWrap: 'nowrap'}" :defaultValue="editItem.interface" @input="editItem.interface=$event"/>
    </div>
    <div class="inputColFlex">
      <div :style="{marginRight: '20px'}">公告期間:</div>
      <DateInput  :defaultValue="editItem.range" @input="editItem.range=$event" :style="{marginRight: 0, marginLeft: 0}"/>
    </div>
    <div class="inputColFlex">
      <div :style="{marginRight: '20px'}">標題:</div>
      <input type="text" v-model="editItem.name">
    </div>
    <div v-if="editItem.mode==='image'" class="inputTextBlock">
      <div>圖片:</div>
      <File :defaultValue="editItem.image" @input="editItem.image=$event" :folder="'announcement'"></File>
    </div>
    <div v-else class="inputTextBlock">
      <div>內容:</div><textarea v-model="editItem.content" ></textarea>
    </div>
    <Btns :style="{marginTop: '50px'}"  @cancel="addnew=false" @save="newPost"/>
  </div>
  </template>
  <template v-else-if="edit">
    <div class="addtitle">編輯公告</div>
    <div class="addcontent">
      <div class="inputColFlex">
        <div :style="{marginRight: '20px'}">公告類型:</div>
        <RT  :defaultValue="editItem.mode==='content'?'文字公告':'圖片公告'" @input="editItem.mode=$event==='文字公告'?'content': 'image'" :options="['文字公告', '圖片公告']"></RT>
      </div>
      <div class="inputColFlex">
        <div :style="{marginRight: '20px'}">公告區域:</div>
        <Checkbox :options="['手機顧客端', '內部系統端']" :style="{flexDirection: 'row', flexWrap: 'nowrap'}" :defaultValue="editItem.interface" @input="editItem.interface=$event"/>
      </div>
      <div class="inputColFlex">
        <div :style="{marginRight: '20px'}">期間:</div><DateInput :defaultValue="editItem.range" @input="editItem.range=$event" :style="{marginRight: 'auto', marginLeft: 0}"/>
      </div>
      <div class="inputColFlex">
        <div :style="{marginRight: '20px'}">標題:</div>
        <input type="text" v-model="editItem.name" :style="{width: '413px'}">
      </div>
      <div v-if="editItem.mode==='image'" class="inputTextBlock">
        <div>圖片:</div>
        <File :defaultValue="editItem.image" @input="editItem.image=$event" :folder="'announcement'"></File>
      </div>
      <div v-else class="inputTextBlock">
        <div>內容:</div><textarea v-model="editItem.content" ></textarea>
      </div>
      <Btns :style="{marginTop: '50px'}"  @cancel="edit=false" @save="updateItem"/>
    </div>
  </template>
  <div v-else class="normalcontent">
    <div id="n2" :style="{display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column'}" v-if="selected">
      <div :style="{fontWeight: 700, fontSize: '28px', letterSpacing: '.1em', color: 'var(--color-pri)'}">{{selected.name}}</div>
      <div :style="{fontWeight: 500, fontSize: '18px', color: '#999999', letterSpacing: '.1em'}">{{toDate(selected.startTime)}} ~ {{toDate(selected.expireTime)}}</div>
      <div class="interface">
        <div v-for="(ifc, i) in selected.interface" :key="`ifc-${i}`">{{ifc==='client'?'手機顧客端':'內部系統端'}}</div>
      </div>
      <div v-if="selected.mode==='image'" :style="{maxWidth: '480px', minWidth: '480px', minHeight: '300px', height: 'fit-content', marginTop: '30px'}"
      ><img :src="`.${selected.image}`" alt="" :style="{maxWidth: '480px', height: 'auto'}" ></div>
      <div v-else :style="{marginTop: '41px', color: '#787878', fontSize: '20px', fontWeight: 400, textAlign: 'start', lineHeight: '1.8em', letterSpacing: '.05em'}"
      v-html="selected.content?.replaceAll('\n', '<br>')"></div>
      <hr :style="{marginTop: '20px', border: 'none', marginBlock: '10px', backgroundColor: 'var(--color-border)', height: '1px', width: '100%'}">
      <div :style="{fontSize: '16px', color: '#999999', letterSpacing: '.1em'}">最初建立人員: {{selected.createBy?.department}} {{selected.createBy?.name}}</div>
      <div :style="{fontSize: '16px', color: '#999999', letterSpacing: '.1em'}">最後編輯人員: {{selected.operator?.department}} {{selected.operator?.name}}</div>
      <div :style="{fontSize: '16px', color: '#999999', letterSpacing: '.1em'}">最後編輯時間: {{moment(selected.updateTime).format('yyyy-MM-DD HH:mm')}}</div>
    </div>
  </div>
  <Dialog :label="'刪除確認'" :show="TEXT"  @close="TEXT=null">
    <div :style="{padding: '40px'}">
      <p :style="{textAlign:'center', fontSize: '20px'}" v-html="TEXT"></p>
      <Btns :save="'確定'" @save="del(deleteArg)" :style="{marginTop: '30px'}" @cancel="TEXT=null"/>
    </div>
  </Dialog>
    </La0>
</template>

<script>
import Dialog from '../../components/dialognoPadding2.vue'
import File from '../../components/input/file.vue'
import Checkbox from '../../components/checkbox/checkbox.vue'
import RoundBtn from '../../components/btn/round.vue'
import DateInput from '../../components/input/dateRange.vue'
import Table from '../../components/tables/t2.vue'
import Btns from '../../components/btn/btns.vue'
import Select from '../../components/select.vue'
import { postapi, deleteapi, getcusapi, putapi } from '../../store/fetch'
import L1 from '../../components/layout/L1.vue'
import La0 from '../../components/layout/La0.vue'
export default {
  components: {
    L1,
    La0,
    Btns,
    Table,
    DateInput,
    RoundBtn,
    Select,
    Checkbox,
    File,
    Dialog
  },
  data () {
    return {
      deleteArg: null,
      TEXT: null,
      selected: null,
      addnew: false,
      edit: false,
      rows: [],
      interfaceid: null,
      id: null,
      editItem: {
        name: null,
        interface: [],
        mode: 'content',
        content: null,
        image: null,
        range: {
          start: null,
          end: null
        }
      }
    }
  },
  async mounted () {
    await this.getdata()
    this.selected = this.rows.length > 0 ? this.rows[0] : null
  },
  watch: {
    interfaceid () {
      this.getdata()
    }
  },
  methods: {
    editfn (item) {
      this.id = item._id
      this.editItem.name = item.name
      this.editItem.mode = item.mode
      this.editItem.image = item.image
      this.editItem.content = item.content
      this.editItem.interface = item.interface.map(e => e === 'client' ? '手機顧客端' : '內部系統端')
      this.editItem.range.start = this.toDate(item.startTime)
      this.editItem.range.end = this.toDate(item.expireTime)
      this.edit = true
    },
    async beforeDel (index, id, name) {
      this.TEXT = `確認要刪除公告"${name}"嗎?`
      this.deleteArg = { index, id }
    },
    async del ({ index, id }) {
      await deleteapi(`announcement/${id}`)
      this.rows.splice(index, 1)
      this.deleteArg = null
      this.TEXT = null
    },
    async getdata () {
      const params = {}
      if (this.interfaceid) {
        params.interface = this.interfaceid
      }
      this.rows = await getcusapi('announcement?' + new URLSearchParams(params))
    },
    async updateItem () {
      const body = {
        name: this.editItem.name ? this.editItem.name : '-',
        content: this.editItem.content ? this.editItem.content : '-',
        mode: this.editItem.mode,
        image: this.editItem.image,
        startTime: this.moment(this.editItem.range.start).startOf('day').toISOString(),
        expireTime: this.moment(this.editItem.range.end).endOf('day').toISOString()
      }
      body.interface = this.editItem.interface.map(e => e === '手機顧客端' ? 'client' : 'staff')
      const ret = await postapi(`announcement/${this.id}`, body)
      const index = this.rows.map(e => e._id).indexOf(this.id)
      this.rows.splice(index, 1, ret)
      this.edit = false
    },
    async newPost () {
      const body = {
        name: this.editItem.name ? this.editItem.name : '-',
        content: this.editItem.content ? this.editItem.content : '-',
        mode: this.editItem.mode,
        image: this.editItem.image,
        startTime: this.moment(this.editItem.range.start).startOf('day').toISOString(),
        expireTime: this.moment(this.editItem.range.end).endOf('day').toISOString()
      }
      body.interface = this.editItem.interface.map(e => e === '手機顧客端' ? 'client' : 'staff')
      const ret = await putapi('announcement', body)
      this.rows.splice(0, 0, ret)
      this.editItem = {
        name: null,
        interface: [],
        mode: 'content',
        content: null,
        image: null,
        range: {
          start: null,
          end: null
        }
      }
      this.addnew = false
    },
    async update (index, id, value) {
      const ret = await postapi(`announcement/${id}`, { actived: value })
      this.rows.splice(index, 1, ret)
    }
  }

}
</script>
<style lang="scss">
.announcementEdit {
  max-height: 100vh!important;
  height: 100vh!important;
  #setDateRange-input {
    letter-spacing: 0;
  }
  .checkboxs-c1 {
    flex-direction: row;
    flex-wrap: nowrap;
  }
  .checkboxqwe {
    color: #787878!important;
    width: 159px!important;
  }
  label.checkboxqwe::before {
    border: 1px solid var(--color-pri);
  }
  label.checkboxqwe.selected::before {
    background-color: var(--color-pri);
  }
  td > svg {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: auto;
  }
  .La0_left {
    margin-top: 0!important;
    margin-left: 22px;
    margin-right: 0!important;
    max-height: 100vh!important;
    height: 100vh!important;
  }
  .La0_right {
    margin-top: 0!important;
    padding: 0;
    gap: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    border-left: 1px solid #CACACA;
    max-height: 100vh!important;
    height: 100vh!important;
  }
  #setDateRange-wrapper, #setDateRange-input {
    height: 40px!important;
    width: 366px!important;
  }
  #setDateRange-wrapper > .field > input[type=text] {
    border: 1px solid var(--color-border);
  }
}
</style>
<style lang="scss" scoped>
#n2 > div {
  padding-inline: 14px;
}
.interface {
  margin-top: 11px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
}
.interface >div {
  width: 150px;
height: 35px;
background: #B9B9B9;
border-radius: 50px;
font-family: 'Noto Sans TC';
font-style: normal;
font-weight: 500;
font-size: 16px;
line-height: 170%;
letter-spacing: 0.1em;
color: #FFFFFF;
display: flex;
align-items: center;
justify-content: center;
}
.normalcontent {
  padding: 59px 45px 30px 35px;
}
.addcontent {
  padding: 30px 59px 30px 49px;
  display: flex;
  align-content: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  gap: 20px;
}
.addtitle {
  text-align: start;
  height: 90px;
  border-bottom: 1px solid #CACACA;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  font-size: 36px;
  line-height: 52px;
  display: flex;
  align-items: center;
  padding-inline: 49px;
  letter-spacing: 0.1em;
  color: var(--color-pri);
}
textarea  {
  width: 100%;
  height: 400px;
  border: 1px solid var(--color-border);
  border-radius: 3px;
  padding-block: 20px;
}
input[type=text] {
  height: 40px;
  width: 500px;
  border: 1px solid var(--color-border);
  border-radius: 3px;
}
input[type=text], textarea {
  box-sizing: border-box;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: .05em;
  padding-inline: .5em;
}
.toolong {
  white-space:nowrap;
  overflow:hidden;
  text-overflow: ellipsis;
  text-align: start;
}
label#uploadimage {
  width: 550px;
  height: 412.5px;
}
.uploadimage {
  margin-right: auto;
  width: 550px;
  height: 412.5px;
  background-image: url(/upload.svg);
  background-size: contain;
  display: inline-flex;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-position: left;
  position: relative;
  &::before {
    position: absolute;
    content: '匯入圖片';
    display: inline-flex;
    width: 100px;
    height: 35px;
    background-color: var(--color-pri);
    align-items: center;
    justify-content: center;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    border-radius: 20px;
    left: 275px;
    top: 243px;
    transform: translateX(-50%);
  }
}
.imageField {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 22px;
  &::before {
    content: attr(label);
    display: inline-flex;
    width: 80px;
    text-align: start;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    color: var(--color-letter);
    text-align: right;
  }
  #uploadimage {
    margin-left: 20px;
  }
}
.inputTextBlock {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: fit-content;
  gap: 20px;
  &>div:nth-child(1) {
    font-family: Roboto;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    letter-spacing: 0.1em;
    color: var(--color-pri);
  }
}
.inputColFlex {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 40px;
  height: fit-content;
  &>div:nth-child(1) {
    font-family: Roboto;
    font-style: normal;
    font-weight: 700;
    color: var(--color-pri);
    font-size: 20px;
    letter-spacing: 0.1em;
    white-space: nowrap;
  }
}
</style>
